/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Select component.
 */
import React, { Component } from 'react';
import { AutoComplete } from 'material-ui';
import { customers, suppliers, invoiceItems } from '../../services';

const services = {
  customers,
  suppliers,
  invoiceItems
};

class RemoteDropDownSearch extends Component {

  constructor(props) {
    super(props);
    this.onUpdateInput = this.onUpdateInput.bind(this);
    this.state = {
      remoteDataSource: [],
      inputValue: '',
      selectedValue: null,
      searchText: this.props.searchText
    };
  }

  onUpdateInput(inputValue) {
    //This API request asumes that the API have a endpoint to get resources using a projection parameter and a containing one.
    // The projection param indicates to the API how the results must be returned. For more information consult the documentation of "Projections" in the API.
    // The containing params is the text entered in the autocomplete component to filter the results in the api.
    this.props.onUpdateInput && this.props.onUpdateInput(inputValue);
    return services[this.props.serviceName].get(this.props.url, { projection: this.props.projectionName, containing: inputValue }).then(result => {
      this.setState({
        remoteDataSource: result._embedded[this.props.entity],
        inputValue: inputValue
      });
    });
  }

  render() {
    const { onAdd, tooltip, label, errorText, dataSourceConfig, searchText, onChange } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
        <div>
          <AutoComplete
            floatingLabelFixed
            dataSource={this.state.remoteDataSource}
            dataSourceConfig={dataSourceConfig}
            errorText={errorText}
            filter={AutoComplete.noFilter}
            onUpdateInput={this.onUpdateInput}
            floatingLabelText={label}
            hintText="Seleccionar"
            listStyle={{ maxHeight: 200, overflow: 'auto', width: 'auto' }}
            fullWidth={false}
            style={{ width: '100%' }}
            textFieldStyle={{ width: '100%' }}
            maxSearchResults={20}
            searchText={searchText}
            onNewRequest={(selectedItem, index) => {
              if (selectedItem != null) {
                onChange(selectedItem);
                this.setState({ ...this.state, searchText: selectedItem.name });
              }
            }}
          />
        </div>
        {
          onAdd && <div className="addnew-button">
            <button onClick={onAdd} title={tooltip}>+</button>
          </div>
        }
      </div>
    );
  }
}

export default RemoteDropDownSearch;



// WEBPACK FOOTER //
// ./components/data-containers/remotedropDownSearch.js